module.exports = __webpack_public_path__ + "static/media/Головко Никита Николаевич Памятник воину - мечтателю Краснодарский край-1.png";